import { apiInstance, gql } from "@/services/httpAdapter.ts";

// Types
import { IPaginatedResponse } from "@Common/api/types/pagination";
import { GraphqlQueryResponse } from "@Common/api/types/GraphqlQueryResponse";

// Fragments
import { FinanceDetailFragment } from "./fragments.ts";

// Helpers
import { errorLogger } from "@Common/helpers/logger.ts";

export async function getFniDetails(args: {
	locationId: string;
	commissionCycleId: string;
	payPeriodId: string;
	first: number;
	after: string;
}) {
	const { locationId, commissionCycleId, payPeriodId, first = 1000, after = "" } = args;

	const query = gql`
		query getFinanceDetails($locationId: String!, $commissionCycleId: String!, $payPeriodId: String!, $pagination: PaginationInput) {
			getFinanceDetails(
				locationId: $locationId
				commissionCycleId: $commissionCycleId
				payPeriodId: $payPeriodId
				pagination: $pagination
			) {
				edges {
					cursor
					node {
						...FinanceDetail
					}
				}
				pageInfo {
					endCursor
					hasNextPage
					totalCount
				}
			}
		}
		${FinanceDetailFragment}
	`;

	const variables = {
		locationId,
		commissionCycleId,
		payPeriodId,
		pagination: {
			first,
			after: after ?? "",
		},
	};

	try {
		const response: GraphqlQueryResponse<"getFinanceDetails", IPaginatedResponse<object>> = await apiInstance.post("/graphql", {
			query,
			variables,
		});
		return response.data.data?.getFinanceDetails;
	} catch (err) {
		errorLogger(err as Error, { function: "getFinanceDetails", message: "Failed to get F&I Details", variables });
		return null;
	}
}
